// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1h0q2","imageUploader":"EGiftCard_imageUploader__2N9W6"};